import uuid from 'uuid-random';
import React, { useEffect, useRef } from 'react';
import { scrollService } from 'js/services/scroll.service';

import style from './Overlay.scss';

export const Overlay = ({ className = '', ...props }) => {
    const lockIdRef = useRef(uuid());

    useEffect(() => {
        const lockId = lockIdRef.current;

        scrollService.disableBodyScroll(lockId);

        return () => scrollService.enableBodyScroll(lockId);
    }, []);

    return (
        <div className={`${style.overlay} ${className}`}
            {...props}>
        </div>
    );
};

export default Overlay;
